import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import TaskDetails from '../../pages/TaskDetails'
import Tasks from '../../pages/Tasks'

const TasksRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/:id`} component={TaskDetails} />

      <Route path={path} component={Tasks} />
    </Switch>
  )
}

export default TasksRoute
